// extracted by mini-css-extract-plugin
export var container = "_6d-0";
export var fallback = "_6d-5";
export var fallbackIcon = "_6d-6";
export var hidden = "_6d-2";
export var image = "_6d-3";
export var loaded = "_6d-4";
export var placeholder = "_6d-1";